import { render, staticRenderFns } from "./memberCredentialNew.vue?vue&type=template&id=05d8ad6d&scoped=true"
import script from "./memberCredentialNew.vue?vue&type=script&lang=js"
export * from "./memberCredentialNew.vue?vue&type=script&lang=js"
import style0 from "./memberCredentialNew.vue?vue&type=style&index=0&id=05d8ad6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d8ad6d",
  null
  
)

export default component.exports